(function () {
  const block = {
    $blocks: document.querySelectorAll('.accreditations'),
    init() {
      if (this.$blocks.length) {
        PubSub.publish('embla.init', {
          name: 'accreditations-carousel',
          $els: this.$blocks,
          options: {
            loop: true
          },
          plugins: [
            EmblaCarouselAutoScroll({
              speed: 0.7,
              playOnInit: false,
              startDelay: 0
            })
          ]
        });
      }
    }
  };

  block.init();
})();

